// Which environment this Osprey instance is operating in.
//
// Osprey is deployed one-host-per-env; the deploy step rewrites `env-config.js`
// with a per-env `NODE_ENV` (development | staging | production). We read that
// runtime value rather than `import.meta.env.MODE` on purpose: a *production*
// Vite build is what ships to every deployed env, so `MODE` is always
// "production" in the browser and cannot tell development from prod. The runtime
// config can.
//
// Ops actions (e.g. storefront go-live) must target the env the operator is
// actually in, so they pass `getAppEnvironment()` explicitly — omitting it makes
// the ops workflow fall back to its own default (production), which would deploy
// a dev-only tenant to prod (or fail on missing prod secrets). Unknown/local
// hosts fall back to `development`, the safe non-production default.
export type AppEnvironment = 'production' | 'staging' | 'development';

const APP_ENVIRONMENTS: readonly AppEnvironment[] = ['production', 'staging', 'development'];

export const getAppEnvironment = (): AppEnvironment => {
  const nodeEnv = (window as unknown as { __RUNTIME_CONFIG__?: { NODE_ENV?: string } })
    .__RUNTIME_CONFIG__?.NODE_ENV;
  return APP_ENVIRONMENTS.includes(nodeEnv as AppEnvironment)
    ? (nodeEnv as AppEnvironment)
    : 'development';
};
